<template>

   <div>
        <div v-if='$root.isLoggedIn() && tBrandSetting("conf_show_global_previous")' class="nhsuk-back-link">
            <a class="nhsuk-back-link__link" href="#" @click.prevent="$root.goBack()">
                <svg class="nhsuk-icon nhsuk-icon__chevron-left" style="fill: #005eb8;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" height="24" width="24">
                    <path d="M8.5 12c0-.3.1-.5.3-.7l5-5c.4-.4 1-.4 1.4 0s.4 1 0 1.4L10.9 12l4.3 4.3c.4.4.4 1 0 1.4s-1 .4-1.4 0l-5-5c-.2-.2-.3-.4-.3-.7z"></path>
            </svg>Back</a>
        </div>

        <div v-if='tBrandSetting("conf_show_top_nav")'>
            <div class="menu__overlay" ref="menuOverlay" v-bind:class="{ menuOverlayShow : toggleMenu }" v-on:click="toggleNav"></div>

            <header id="patientHeader" ref='patientHeader' class="p-2 align-items-center d-flex flex-row header-patient">
                
                <router-link :to="{name: 'Profile'}" active-class="" tag="div" :class="'text-left icon-brand ' + ($root.embed ? ' icon-brand-embed' : '')"></router-link>
                
                <div class="flex-grow-1 text-left gp-practice">{{providerName}} {{providerStatus}}</div>

                <div class="text-right">
                    <div class="d-flex align-items-center" style="padding: 0 10px;">

                        <div class="locale-changer mr-2"  v-if='!$root.isLoggedIn() && environment_settings.MIX_ENABLE_LANGUAGE_SELECTION'>
                            <label class="sr-only" for="set_language">{{ $t('translations.language') }}</label>
                            <select class="form-control custom-select" v-model="locale" v-on:change="setLocale" id="set_language">
                                <option :key='key' v-for="(lang, key) in $root.lookup.langs" :value="key" placeholder="language">{{ lang }}</option>
                            </select>
                        </div>

                        <a href='https://evergreenlife.freshdesk.com/support/solutions/14000076324' target="_blank" style="width: 33px; height: 33px;" class="mr-2"><span class="sr-only">Help Desk</span>
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="10px" viewBox="0 0 50 50" width="33" height="33" xml:space="preserve" class="mr-2">
                                <path d="M25,1C11.7,1,1,11.7,1,25c0,13.3,10.7,24,24,24s24-10.7,24-24C49,11.7,38.3,1,25,1z M28,39h-5.6v-5.4H28V39z
                                M33.3,23.2c-0.5,0.7-1.4,1.5-2.7,2.6l-1.3,1c-0.7,0.6-1.2,1.2-1.4,2c-0.2,0.5-0.2,1.2-0.2,2.2h-5.1c0.1-2.1,0.3-3.6,0.6-4.4
                                c0.3-0.8,1.2-1.7,2.5-2.8l1.4-1.1c0.4-0.3,0.8-0.7,1.1-1.1c0.5-0.7,0.7-1.4,0.7-2.3c0-1-0.3-1.8-0.8-2.6c-0.6-0.8-1.6-1.2-3-1.2
                                c-1.5,0-2.5,0.5-3.1,1.4c-0.6,1-0.9,2-0.9,3h-5.4c0.2-3.6,1.4-6.1,3.7-7.6c1.5-1,3.3-1.4,5.5-1.4c2.8,0,5.2,0.7,7.1,2
                                c1.9,1.4,2.8,3.4,2.8,6C34.5,20.7,34.1,22.1,33.3,23.2z" class="st0"></path>
                            </svg>
                        </a>
                        <div>
                            <router-link v-if="!$root.isLoggedIn()" :to="{name: 'loginForm', params: {next: 'Profile'}}" class="btn btn-sm btn-round btn-primary">{{ $t('translations.log_in')}}</router-link>
                            <a v-else href="/logout" class="btn btn-sm btn-round btn-primary mr-3">{{ $t('translations.logout')}}</a>
                        </div>
                        <div v-if="$root.isLoggedIn() && tBrandSetting('conf_show_menu')" class="menu-icon  d-flex align-items-center" v-on:click="toggleNav" v-bind:class="{ menuOverlayShow : toggleMenu }">
                            <button type="button">
                                <span class="sr-only">{{$t('translations.open_menu')}}</span>
                                <svg ref="menuIcon" class="menu__icon no--select" width="24px" height="24px" viewBox="0 0 48 48" fill="#1A72A0">
                                <path class="st0" d="M6 36h36v-4H6v4zm0-10h36v-4H6v4zm0-14v4h36v-4H6z"></path>
                            </svg>
                            </button> 
                        </div>

                        
                    </div>
                </div>

                <div class="menu" ref="menu" v-bind:class="{menuShow : toggleMenu}">

                    <div class="menu__list flex-column">
                        <div class="menu__header">
                            <button class="d-flex align-items-center close-toggle" v-on:click="toggleNav">
                                <span class="sr-only">{{$t('translations.close_menu')}}</span>
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                    viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve" class="close-icon">
                                    <line class="close-icon-line" x1="25" y1="5.5" x2="6" y2="24.5"/>
                                    <line class="close-icon-line" x1="6" y1="5.5" x2="25" y2="24.5"/>
                                </svg>
                            </button>

                        </div>

                        <template v-if="$root.isLoggedIn()">

                            <div v-on:click="toggleNav">
                                <router-link :to="{name: 'Profile'}">{{ $t('translations.home')}}</router-link>
                                <!-- <p v-if='!isServiceAvailable()' class="m-2 alert alert-warning" >
                                    <template v-if='$root.provider.network_service_status == 0'>
                                        {{autobrand('translations.network_is_currently_unavailable_for_online_requests')}}
                                    </template>
                                    <template v-else>
                                        {{ serviceAvailabliltyMessage() }}
                                    </template>
                                </p> -->
                                <router-link v-if='tBrandSetting("conf_show_new_request") && (isServiceAvailable() || (isOohUnavailable() && outOfHoursCustomActions().length))' :to='{name: "accessType", params: {action: "form"}}' class="">{{ autobrand('translations.new_request')}}</router-link>
                                <router-link v-if='tBrandSetting("conf_view_past_requests")' :to='$root.isLoggedIn() ? {name: "threadList"} : {name: "loginType"}' class="">{{ autobrand('translations.view_past_requests')}}</router-link>
                                <router-link v-if='tBrandSetting("conf_edit_my_details_menu")' :to='{name: "ProfileEdit"}' class="">{{ $t('translations.edit_my_details')}}</router-link>
                                <router-link v-if='tBrandSetting("conf_proxy_menu")' :to='{name: "SelectCaree"}' class="">{{ autobrand('translations.people_i_care_for') }}</router-link>
                                <router-link v-if='tBrandSetting("conf_our_service_times")' :to="{name: 'serviceTimes'}" class="">{{ tBrandKey('our_service_times') }}</router-link>
                                <router-link v-if='tBrandSetting("conf_when_is_your_clinician_working")' :to="{name: 'staffAvailability'}" class="">{{ $t('translations.when_is_your_GP_working')}}</router-link>
                                <div><a href='https://evergreenlife.freshdesk.com/support/solutions/14000076324' class="">{{ $t('translations.help')}}</a></div>
                                <div v-if='tBrandSetting("conf_show_logout")'><a href="/logout" class="">{{ $t('translations.logout')}}</a></div>
                            </div>
                            <div class="mt-auto">
                                <div v-if='tBrandSetting("conf_notification_option") && displayNone === false' class="p-2" v-on:click="toggleNav">
                                    <notification-button></notification-button>
                                </div>
                                <div v-if='tBrandSetting("conf_install_option") && displayNone === false' class="p-2" v-on:click="toggleNav">
                                    <install-button></install-button>
                                </div>
                            </div>

                        </template>
                    </div>
                </div>

            </header>
        </div>
    </div>
</template>

<script>
export default {
    props: [
    ],
    data: function(){
        return {
            toggleMenu: false,
            displayNone: true,
            locale: 'en',
        };
    },
    mounted() {
        this.locale = this.$root.getLocale();
    },
    computed: {
        providerName: function() {
            if(this.$root.provider) {
                return this.$root.provider.name;
            }
            return "";
        },
        providerStatus: function() {
            if(!this.isServiceAvailable()) {
                return "(" + this.$t('translations.offline') + ")"
            }
            return "";
        },

    },
    methods: {
        toggleNav() {
            this.toggleMenu = !this.toggleMenu;
        },
        setLocale() {
            Vue.nextTick(() => {
                this.$root.setLocale(this.locale);
            });
        }

    },

    created: function() {
        // Hide notification button if browser doesnt allow service worker
        try {
            if (typeof ServiceWorkerRegistration != "undefined" && 'showNotification' in ServiceWorkerRegistration.prototype) {
                this.displayNone = false;
            } else {
                this.displayNone = true;
            }
        }
        catch(e) {
            //console.error("Error setting up service worker.")
            // We ignore any ReferenceError exceptions here.
            this.displayNone = true;
        }
    }
}
</script>

<style type="text/css">
.st0{fill:#1a72a0;}

</style>
